export const STATUS_TEXT = {
  ALL: 'All',
  COMPLETE: 'Complete',
  DESIGNATION_IN_PROGRESS: 'Designation In Progress',
  INITIAL_NOTICE_COMPLETE: 'Initial Notice Complete',
  INITIAL_NOTICE_IN_PROGRESS: 'Initial Notice In Progress',
}
